// A header checkbox ticks or unticks every row checkbox, mirrors their state (part-ticked included),
// counts the selection and reveals bulk actions once anything is ticked. Fires
// "checkbox-select-all:changed" with the selected count after every change, so other controllers can
// react once the rows are up to date instead of racing this one for the same change event.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkboxAll", "checkbox", "counter", "bulkActions"]

  initialize() {
    this.toggle = this.toggle.bind(this)
    this.refresh = this.refresh.bind(this)
  }

  checkboxAllTargetConnected(checkbox) {
    checkbox.addEventListener("change", this.toggle)
    this.scheduleRefresh()
  }

  checkboxAllTargetDisconnected(checkbox) {
    checkbox.removeEventListener("change", this.toggle)
  }

  checkboxTargetConnected(checkbox) {
    checkbox.addEventListener("change", this.refresh)
    this.scheduleRefresh()
  }

  checkboxTargetDisconnected(checkbox) {
    checkbox.removeEventListener("change", this.refresh)
    this.scheduleRefresh()
  }

  toggle(event) {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = event.target.checked })
    this.refresh()
  }

  refresh() {
    if (!this.hasCheckboxAllTarget) return

    const checkboxes = this.checkboxTargets
    const selected = checkboxes.filter((checkbox) => checkbox.checked).length
    this.checkboxAllTarget.checked = selected > 0
    this.checkboxAllTarget.indeterminate = selected > 0 && selected < checkboxes.length

    if (this.hasCounterTarget) this.counterTarget.textContent = selected
    if (this.hasBulkActionsTarget) this.bulkActionsTarget.classList.toggle("hidden", selected === 0)
    this.dispatch("changed", { detail: { selected } })
  }

  scheduleRefresh() {
    if (this.refreshScheduled) return

    this.refreshScheduled = true
    queueMicrotask(() => {
      this.refreshScheduled = false
      this.refresh()
    })
  }
}
